module.exports = __webpack_public_path__ + "img/android-chrome-512x512.df9033d5.png";